import React from "react";
import { Redirect, Route } from "react-router-dom";
import { isAuthenticated } from "../helpers/session";
import config from "../config";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={config.loginUrl} />
        )
      }
    />
  );
};

export default PrivateRoute;
